import React, { MouseEventHandler } from "react";
import { plan2plateIcons } from "../utils/iconUtils";

export function Plan2PlateIcon(props: {
  icon: keyof typeof plan2plateIcons;
  size?: "sm" | "xs" | "xxs";
  onClick?: MouseEventHandler<HTMLSpanElement>;
  stroke?: string;
}) {
  const sizes = {
    base: 38,
    sm: 25,
    xs: 18,
    xxs: 16,
  };

  const size = props.size ? sizes[props.size] : sizes.base;
  const stroke = props.stroke;

  return (
    <span
      className="p2p-svg inline-flex shrink-0 items-center justify-center"
      style={{
        width: size,
        height: size,
        ...(stroke ? ({ "--p2p-text": stroke } as React.CSSProperties) : {}),
      }}
      onClick={props.onClick}
    >
      {plan2plateIcons[props.icon]}
    </span>
  );
}
